import { useQuery } from "@tanstack/react-query";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { FullSizeLoader } from "@/components/FullSizeLoader/FullSizeLoader";
import { useDeleteRole } from "@/modules/roles/hooks/useDelete";
import { usePermissionQueries } from "@/queries/permissions";

import type { LayoutProps } from "./Layout";

interface Props {
  children: (props: LayoutProps) => React.ReactNode;
}

export function Loader(props: Props): React.ReactNode {
  const permissionQueries = usePermissionQueries();
  const { data: roles, isPending, error } = useQuery(permissionQueries.listRoles());
  const { mutateAsync: deleteRole } = useDeleteRole();

  if (error) {
    return <ErrorPage error={error} />;
  }

  if (isPending) {
    return <FullSizeLoader withPadding />;
  }

  return props.children({ roles, deleteRole });
}
